export var CommissionJobType;
(function (CommissionJobType) {
    CommissionJobType[CommissionJobType["NewInstall"] = 0] = "NewInstall";
    CommissionJobType[CommissionJobType["DeommissionAndRecommission"] = 1] = "DeommissionAndRecommission";
})(CommissionJobType || (CommissionJobType = {}));
